module.exports = __webpack_public_path__ + "static/media/037.841702c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/normals/037.jpg
// module id = 333
// module chunks = 0